var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateCabinCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 12.5C12.5 10.5109 13.2902 8.60322 14.6967 7.1967C16.1032 5.79018 18.0109 5 20 5C21.9891 5 23.8968 5.79018 25.3033 7.1967C26.7098 8.60322 27.5 10.5109 27.5 12.5V17.5H12.5V12.5ZM7.5 17.5V12.5C7.5 9.18479 8.81696 6.00537 11.1612 3.66117C13.5054 1.31696 16.6848 0 20 0C23.3152 0 26.4946 1.31696 28.8388 3.66117C31.183 6.00537 32.5 9.18479 32.5 12.5V17.5H37.5C38.163 17.5 38.7989 17.7634 39.2678 18.2322C39.7366 18.7011 40 19.337 40 20V42.5C40 44.4891 39.2098 46.3968 37.8033 47.8033C36.3968 49.2098 34.4891 50 32.5 50H7.5C5.51088 50 3.60322 49.2098 2.1967 47.8033C0.790177 46.3968 0 44.4891 0 42.5V20C0 19.337 0.263393 18.7011 0.732234 18.2322C1.20107 17.7634 1.83696 17.5 2.5 17.5H7.5ZM22.5 33.75C22.5 32.7554 22.8951 31.8016 23.5984 31.0983C24.3016 30.3951 25.2554 30 26.25 30H26.275C27.2696 30 28.2234 30.3951 28.9267 31.0983C29.6299 31.8016 30.025 32.7554 30.025 33.75V33.775C30.025 34.7696 29.6299 35.7234 28.9267 36.4267C28.2234 37.1299 27.2696 37.525 26.275 37.525H26.25C25.2554 37.525 24.3016 37.1299 23.5984 36.4267C22.8951 35.7234 22.5 34.7696 22.5 33.775V33.75Z",
    fill: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateCabinCard);
export default __webpack_public_path__ + "static/media/private-cabin-card.0c7ba446f665737c10988e8c5a32d40e.svg";
export { ForwardRef as ReactComponent };